import Instance from "../../../../Axios";

// New Actions for the app

const GetTotalCredMes = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/totalCredenciacoesMes`)
    .then(({ data }) => {
      dispatch({
        type: "GET_TOTAL_CREDENCIACOES_MES",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetTotalCredMes;
